import { combineReducers } from "@reduxjs/toolkit";
import { api } from "api/generated";

import answerReducer from "./slices/answer";
import assignmentsReducer from "./slices/assignments";
import assignmentNavigationReducer from "./slices/assignmentNavigation";
import blacklistItemsReducer from "./slices/blacklistItems";
import bookmarksReducer from "./slices/bookmarks";
import envelopeNavigationReducer from "./slices/envelopeNavigation";
import exerciseReducer from "./slices/exercise";
import invalidTokenReducer from "./slices/invalidToken";
import queryParamsReducer from "./slices/queryParams";
import sessionConflictReducer from "./slices/sessionConflict";
import timerReducer from "./slices/timer";
import tokenReducer from "./slices/token";
import topicPracticeReducer from "./slices/topicPractice";
import timetableReducer from "./slices/timetable";
import userReducer from "./slices/user";
import userBooksReducer from "./slices/userBooks";

const rootReducer = combineReducers({
  api: api.reducer,
  answer: answerReducer,
  assignments: assignmentsReducer,
  assignmentsNavigation: assignmentNavigationReducer,
  blacklistItems: blacklistItemsReducer,
  bookmarks: bookmarksReducer,
  envelopeNavigation: envelopeNavigationReducer,
  exercise: exerciseReducer,
  invalidToken: invalidTokenReducer,
  queryParams: queryParamsReducer,
  sessionConflict: sessionConflictReducer,
  timer: timerReducer,
  token: tokenReducer,
  topicPractice: topicPracticeReducer,
  timetable: timetableReducer,
  user: userReducer,
  userBooks: userBooksReducer,
});

export default rootReducer;
